namespace RedBullMOBILE360.CVM {
    export interface OfferRedemptionForm {
        SegmentId: Serenity.IntegerEditor;
        Msisdn: Serenity.StringEditor;
        RedemptionDate: Serenity.DateEditor;
    }

    export class OfferRedemptionForm extends Serenity.PrefixedContext {
        static formKey = 'CVM.OfferRedemption';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OfferRedemptionForm.init)  {
                OfferRedemptionForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;

                Q.initFormType(OfferRedemptionForm, [
                    'SegmentId', w0,
                    'Msisdn', w1,
                    'RedemptionDate', w2
                ]);
            }
        }
    }
}
